/**
 * セッションストレージのキー名
 * 他サイトのキー名と重複しないようにすること
 */
export const SessionStorageKey = {
  // 流入元情報の識別子
  TRAFFIC_SOURCE_ID: "@@dmweb/trafficSourceId",
} as const;
